import PropTypes from 'prop-types';

export const SPACING = [
  'spacing-0',
  'spacing-4-xs',
  'spacing-3-xs',
  'spacing-2-xs',
  'spacing-xs',
  'spacing-s',
  'spacing-m',
  'spacing-l',
  'spacing-xl',
  'spacing-2-xl',
  'spacing-3-xl',
  'spacing-4-xl',
];

export const PADDING_PROP_TYPES = {
  padding: PropTypes.oneOf(SPACING),
  paddingTop: PropTypes.oneOf(SPACING),
  paddingRight: PropTypes.oneOf(SPACING),
  paddingBottom: PropTypes.oneOf(SPACING),
  paddingLeft: PropTypes.oneOf(SPACING),
};

export const MARGIN_PROP_TYPES = {
  margin: PropTypes.oneOf(SPACING),
  marginTop: PropTypes.oneOf(SPACING),
  marginRight: PropTypes.oneOf(SPACING),
  marginBottom: PropTypes.oneOf(SPACING),
  marginLeft: PropTypes.oneOf(SPACING),
};
